// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"Airplane_bgVideoWrapper__CGK1g","imgWrapper":"Airplane_imgWrapper__1543V"};